// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"_1n7QO5R1lSZS-U1VN_JXJ1"};